import { AlertCircle } from 'lucide-react'

export default function FormField({
  label,
  name,
  type = 'text',
  placeholder,
  value,
  onChange,
  onBlur,
  error,
  required = false,
  options = [], // For select fields
  rows = 4, // For textarea
  className = '',
  ...props
}) {
  const baseInputClasses = `
    w-full p-4 border rounded-lg transition-colors
    focus:outline-none focus:ring-2 focus:ring-c9-orange
    ${error 
      ? 'border-red-500 bg-red-50' 
      : 'border-gray-300 bg-white hover:border-gray-400'
    }
    ${className}
  `

  const handleChange = (e) => {
    onChange(name, e.target.value)
  }

  const handleBlur = (e) => {
    if (onBlur) {
      onBlur(name, e.target.value)
    }
  }

  const renderInput = () => {
    switch (type) {
      case 'textarea':
        return (
          <textarea
            id={name}
            name={name}
            placeholder={placeholder}
            value={value || ''}
            onChange={handleChange}
            onBlur={handleBlur}
            rows={rows}
            className={baseInputClasses}
            {...props}
          />
        )
      
      case 'select':
        return (
          <select
            id={name}
            name={name}
            value={value || ''}
            onChange={handleChange}
            onBlur={handleBlur}
            className={baseInputClasses}
            {...props}
          >
            <option value="">{placeholder}</option>
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        )
      
      default:
        return (
          <input
            type={type}
            id={name}
            name={name}
            placeholder={placeholder}
            value={value || ''}
            onChange={handleChange}
            onBlur={handleBlur}
            className={baseInputClasses}
            {...props}
          />
        )
    }
  }

  return (
    <div className="mb-6">
      {label && (
        <label htmlFor={name} className="block text-sm font-semibold text-gray-700 mb-2">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      
      {renderInput()}
      
      {error && (
        <div className="flex items-center mt-2 text-red-600 text-sm">
          <AlertCircle className="h-4 w-4 mr-1 flex-shrink-0" />
          <span>{error}</span>
        </div>
      )}
    </div>
  )
}
